import PropTypes from 'prop-types'
import React from 'react'
import classes from '../Content.module.scss'

export class ContentHeader extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func
  }

  render () {
    let {
      className,
      onClick,

      children,

      ...restProps
    } = this.props

    let compClassName = classes.header
    if (className) compClassName += ' ' + className
    if (onClick) compClassName += ' ' + classes.hoverable

    return (
      <div
        {...restProps}
        className={compClassName}
        onClick={onClick}
      >
        {children}
      </div>
    )
  }
}

export default ContentHeader
